module.exports = global["React"] = require("-!/Users/mkramer/Code/masondotnet/node_modules/react/react.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?React!./~/react/react.js
// module id = 77
// module chunks = 0